import { createContext, useContext } from "react";
import { useImmerReducer } from "use-immer";
import { reducer, initialState} from "../app-state";

export const AppContext = createContext(null);

export function AppProvider({ children }) {
	const [state, dispatch] = useImmerReducer(reducer, initialState);

	return <AppContext.Provider value={{state, dispatch}}>{children}</AppContext.Provider>;
}

export function useAppContext() {
	return useContext(AppContext);
}
